
module.exports = {
  // TODO: change your profile information here
  name: "Pinki Kumari",
  greeting: "Hey 👋",
  greetingDescription: "I'm Pinki Kumar and I'm a Software Engineer!",
  githubUrl: "https://github.com/kumari858",
  linkedinUrl: "https://www.linkedin.com/in/pinki-kumari-74370a17a",
  cvLink: "https://drive.google.com/file/d/1YvxCX2lytE0Ko-cQ-88WMZjGrrQP5QK8/",
};
